import React from 'react';
import AListItem from 'antd-mobile/lib/list/ListItem.web';



export default class ListItem extends AListItem {}
